import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';

type SpacerColor = 'Black' | 'Bronze' | 'Mill';

interface AluminumSpacerColorModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedColor: SpacerColor | undefined;
  onColorSelect: (color: SpacerColor) => void;
}

const AluminumSpacerColorModal: React.FC<AluminumSpacerColorModalProps> = ({
  open,
  onOpenChange,
  selectedColor,
  onColorSelect,
}) => {
  const [color, setColor] = React.useState<SpacerColor>(selectedColor || 'Black');

  // Reset color when modal opens
  React.useEffect(() => {
    if (open) {
      setColor(selectedColor || 'Black');
    }
  }, [open, selectedColor]);

  const handleSave = () => {
    onColorSelect(color);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[350px] bg-[#0f172a] text-white border-none">
        <DialogHeader>
          <DialogTitle className="text-[#60a5fa] text-xl">
            Select Aluminum Spacer Color
          </DialogTitle>
        </DialogHeader>

        <div className="py-4">
          <RadioGroup
            value={color}
            onValueChange={(value) => setColor(value as SpacerColor)}
            className="space-y-4"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="Black" id="black" />
              <Label htmlFor="black" className="cursor-pointer">Black</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="Bronze" id="bronze" />
              <Label htmlFor="bronze" className="cursor-pointer">Bronze</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="Mill" id="mill" />
              <Label htmlFor="mill" className="cursor-pointer">Mill</Label>
            </div>
          </RadioGroup>
        </div>

        <DialogFooter>
          <Button
            onClick={handleSave}
            className="bg-blue-600 hover:bg-blue-700 text-white"
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AluminumSpacerColorModal;
